<mat-card class="card">
    <mat-card-content>
        <div class="row payment">
            <div class="col-xs-12 col-sm-6 payment-method">
                <div class="payment-method-title">
                    <span>{{ 'Moyen de paiement par defaut' | transloco }}</span>
                    <a (click)="viewMoreMethod()" *ngIf="onlyView" class="more-link">
                        {{ 'En savoir plus' | transloco }}
                    </a>
                </div>
                <div *ngIf="loadingPaymentProfile === true" class="loading">
                    <mat-spinner [diameter]="30"></mat-spinner>
                </div>
                <div
                    *ngIf="loadingPaymentProfile === false && defaultPaiementProfile !== null"
                    class="payment-method-type"
                >
                    <div class="payment-method-type__icon">
                        <img
                            *ngIf="
                                defaultPaiementProfile.details_type === 'prepaid' &&
                                defaultPaiementProfile.default === true
                            "
                            [alt]="'Compte prepaye' | transloco"
                            src="assets/images/payment/prepaid_account.svg"
                        />
                        <img
                            *ngIf="
                                defaultPaiementProfile.details_type === 'card' &&
                                defaultPaiementProfile.default === true
                            "
                            [alt]="'Carte de credit' | transloco"
                            [src]="defaultPaiementProfile.iconUrl"
                        />
                    </div>
                    <div class="payment-method-type__card-number">
                        <ng-container *ngIf="defaultPaiementProfile.details_type === 'card'">
                            **** **** ****
                            {{ defaultPaiementProfile.details.last4 }}
                        </ng-container>
                        <ng-container *ngIf="defaultPaiementProfile.details_type === 'prepaid'">
                            {{ 'Compte prepaye' | transloco }}
                        </ng-container>
                    </div>
                    <div *ngIf="!onlyView && paiementProfiles.length > 1" class="payment-method-type__modify">
                        <a (click)="changePaymentMethod()">
                            {{ 'Modifier' | transloco }}
                        </a>
                    </div>
                </div>
            </div>
            <!-- <div class="col-sm-1 offset-sm-1 payment-method-separator"></div> -->
            <div class="col-xs-12 col-sm-6 payment-billing">
                <div class="payment-billing-title">
                    <span>{{ 'Adresse de facturation par defaut' | transloco }}</span>
                    <a (click)="viewMoreBilling()" *ngIf="onlyView" class="more-link">
                        {{ 'En savoir plus' | transloco }}
                    </a>
                </div>
                <div *ngIf="loadingAddress === true" class="loading">
                    <mat-spinner [diameter]="30"></mat-spinner>
                </div>
                <ng-container *ngIf="loadingAddress === false && defaultBillingAddress !== null">
                    <div class="payment-billing-address">
                        <div class="address">
                            <div class="address__organization">
                                {{
                                    defaultBillingAddress.organization_name
                                        ? defaultBillingAddress.organization_name
                                        : selectedAccount?.name
                                }}
                            </div>
                            <div class="address__address">
                                {{ defaultBillingAddress.street }}, {{ defaultBillingAddress.zip_code }}
                                {{ defaultBillingAddress.city }} ({{ defaultBillingAddress.country }})
                            </div>
                        </div>
                        <div *ngIf="!onlyView && billingAddresses.length > 1" class="modify">
                            <a (click)="changeBillingAddress()">
                                {{ 'Modifier' | transloco }}
                            </a>
                        </div>
                    </div>
                </ng-container>
            </div>
        </div>
    </mat-card-content>
</mat-card>
